import Layout from '@/components/layout/Layout.vue'
import TitleGroup from '@/components/title-group/TitleGroup.vue'

export default {
    name: 'title_group',
    components: {
        Layout,
        TitleGroup,
    },
    data() {
        return {
           
        }
    },
    mounted() {
    },
    methods: {
        
    }
}
